<template>
    <div v-if="showVouchers" hidden>
        <!--via cliente -->
        <div ref="customer">
            <div class="copy">
                <div class="row">
                    <div class="text-center">
                        <img :src="logoSRC" width="40%" alt="Não foi possível carregar a logo Facilita" />
                        <br/>
                        <br/>
                        <h5>Comprovante de Pagamento</h5>
                        (Via do Cliente)
                        <hr/>
                    </div>
                    <div class="col-xs-12">
                        <div class="text-center">
                            <h5>Dados do Cliente</h5>
                            <br/>
                        </div>
                        <p>
                            Cliente: <span class="info">{{ control.deal.customer.name }}</span><br/>
                            <span v-if="control.deal.owners">
                                <span v-if="control.deal.owners.broker">
                                    Corretor(a): <span class="info">{{ control.deal.owners.broker.user.first_name }}</span><br/>
                                </span>
                                <span v-if="control.deal.owners.team">
                                    Equipe: <span class="info">{{ control.deal.owners.team.name }}</span><br/>
                                </span>
                            </span>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <div class="text-center">
                            <br/>
                            <h5>Dados da(s) Unidade(s)</h5>
                            <br/>
                        </div>

                        <ul class="units-sold">
                            <li v-for="(unit, index) in data.units" :key="index">{{ unitInfos(unit) }}</li>
                        </ul>
                    </div>
                    <div class="col-xs-12">
                        <div class="text-center">
                            <br/>
                            <h5>Dados do Pagamento</h5>
                            <br/>
                        </div>
                        <ul class="payment-data">
                            <li v-for="(payment, index) of data.payments" :key="index">
                                {{ payment?.category?.name }} / {{ payment?.subcategory?.name || '-' }}
                                <span>{{ payment.value | currencyBRL }} </span>
                                <br/>
                                <template v-if="payment.observations">
                                    <small> (obs: <span> {{ payment.observations }} </span>)</small>
                                    <br/>
                                </template>
                            </li>
                        </ul>
                        <br/>
                    </div>
                    <div class="box-footer">
                        <div class="text-center">
                            <br/>
                            <h5>Resumo</h5>
                            <br/>
                        </div>

                        Valor Total da(s) Unidade(s):
                        <span class="units-total-value">
                            {{ data.total_value | currencyBRL }}
                        </span>
                        <br/>

                        Valor Total a ser Pago:
                        <span class="total-entry">
                            {{ data.entry_value | currencyBRL }}
                        </span>
                        <br/>

                        Valor Total Recebido:
                        <span class="total-received">
                            {{ data.summary_value | currencyBRL }}
                        </span>
                        <br/>

                        Operador/Caixa: <span class="box-operator">{{ user.first_name }}</span><br/>
                    </div>

                    Data/Hora: 
                    <span class="payment-data">
                        {{ data.created_at | moment('DD/MM/YYYY [às] HH:mm') }}
                    </span>
                    <br/>
                </div>
                <br/>
                <br/>
                <p class="text-center">
                    <small>Desenvolvido por <b>www.appfacilita.com </b></small>
                </p>
                <br/>
                <hr/>
                <br/>
            </div>
        </div>
        <!--via caixa -->
        <div ref="box">
            <div class="copy">
                <div class="row">
                    <div class="text-center">
                        <img :src="logoSRC" width="40%" alt="Não foi possível carregar a logo Facilita" />
                        <br/>
                        <br/>
                        <h5>Comprovante de Pagamento</h5>
                        (Via do Caixa)
                        <hr/>
                    </div>
                    <div class="col-xs-12">
                        <div class="text-center">
                            <h5>Dados do Cliente</h5>
                            <br/>
                        </div>
                        <p>
                            Cliente: <span class="info">{{ control.deal.customer.name }}</span><br/>
                            <span v-if="control.deal.owners">
                                <span v-if="control.deal.owners.broker">
                                    Corretor(a): <span class="info">{{ control.deal.owners.broker.user.first_name }}</span><br/>
                                </span>
                                <span v-if="control.deal.owners.team">
                                    Equipe: <span class="info">{{ control.deal.owners.team.name }}</span><br/>
                                </span>
                            </span>
                            Etapa/Status:
                            <span class="info">{{ control.deal.stage ? control.deal.stage.name : '-' }}</span>/
                            <span class="info">{{ control.deal.status ? control.deal.status.name : '-' }}</span>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <div class="text-center">
                            <br/>
                            <h5>Dados da(s) Unidade(s)</h5>
                            <br/>
                        </div>

                        <ul class="units-sold">
                            <li v-for="(unit, index) in data.units" :key="index">{{ unitInfos(unit) }}</li>
                        </ul>
                    </div>
                    <div class="col-xs-12">
                        <div class="text-center">
                            <br/>
                            <h5>Dados do Pagamento</h5>
                            <br/>
                        </div>
                        <ul class="payment-data">
                            <li v-for="(payment, index) of data.payments" :key="index">
                                {{ payment?.category?.name }} / {{ payment?.subcategory?.name || '-' }}
                                <span>{{ payment.value | currencyBRL }} </span>
                                <br/>
                                <template v-if="payment.observations">
                                    <small> (obs: <span> {{ payment.observations }} </span>)</small>
                                    <br/>
                                </template>
                            </li>
                        </ul>
                        <br/>
                    </div>
                    <div class="box-footer">
                        <div class="text-center">
                            <br/>
                            <h5>Resumo</h5>
                            <br/>
                        </div>

                        Valor Total da(s) Unidade(s):
                        <span class="units-total-value">
                            {{ data.total_value | currencyBRL }}
                        </span>
                        <br/>

                        Valor Total a ser Pago:
                        <span class="total-entry">
                            {{ data.entry_value | currencyBRL }}
                        </span>
                        <br/>

                        Valor Total Recebido:
                        <span class="total-received">
                            {{ data.summary_value | currencyBRL }}
                        </span>
                        <br/>

                        Operador/Caixa: <span class="box-operator">{{ user.first_name }}</span><br/>
                    </div>

                    Data/Hora: 
                    <span class="payment-data">
                        {{ data.created_at | moment('DD/MM/YYYY [às] HH:mm') }}
                    </span>
                    <br/>
                </div>
                <br/>
                <br/>
                <p class="text-center">
                    <small>Desenvolvido por <b>www.appfacilita.com </b></small>
                </p>
            </div>
        </div>
        <!--via corretor -->
        <div ref="broker">
            <div class="copy">
                <div class="row">
                    <div class="text-center">
                        <img :src="logoSRC" width="40%" alt="Não foi possível carregar a logo Facilita" />
                        <br/>
                        <br/>
                        <h5>Comprovante de Pagamento</h5>
                        (Via do Corretor)
                        <hr/>
                    </div>
                    <div class="col-xs-12">
                        <div class="text-center">
                            <h5>Dados do Cliente</h5>
                            <br/>
                        </div>
                        <p>
                            Cliente: <span class="info">{{ control.deal.customer.name }}</span><br/>
                            <span v-if="control.deal.owners">
                                <span v-if="control.deal.owners.broker">
                                    Corretor(a): <span class="info">{{ control.deal.owners.broker.user.first_name }}</span><br/>
                                </span>
                                <span v-if="control.deal.owners.team">
                                    Equipe: <span class="info">{{ control.deal.owners.team.name }}</span><br/>
                                </span>
                            </span>
                            Etapa/Status:
                            <span class="info">{{ control.deal.stage ? control.deal.stage.name : '-' }}</span>/
                            <span class="info">{{ control.deal.status ? control.deal.status.name : '-' }}</span>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <div class="text-center">
                            <br/>
                            <h5>Dados da(s) Unidade(s)</h5>
                            <br/>
                        </div>

                        <ul class="units-sold">
                            <li v-for="(unit, index) in data.units" :key="index">{{ unitInfos(unit) }}</li>
                        </ul>
                    </div>
                    <div class="col-xs-12">
                        <div class="text-center">
                            <br/>
                            <h5>Dados do Pagamento</h5>
                            <br/>
                        </div>
                        <ul class="payment-data">
                            <li v-for="(payment, index) of data.payments" :key="index">
                                {{ payment?.category?.name }} / {{ payment?.subcategory?.name || '-' }}
                                <span>{{ payment.value | currencyBRL }} </span>
                                <br/>
                                <template v-if="payment.observations">
                                    <small> (obs: <span> {{ payment.observations }} </span>)</small>
                                    <br/>
                                </template>
                            </li>
                        </ul>
                        <br/>
                    </div>
                    <div class="box-footer">
                        <div class="text-center">
                            <br/>
                            <h5>Resumo</h5>
                            <br/>
                        </div>

                        Valor Total da(s) Unidade(s):
                        <span class="units-total-value">
                            {{ data.total_value | currencyBRL }}
                        </span>
                        <br/>

                        Valor Total a ser Pago:
                        <span class="total-entry">
                            {{ data.entry_value | currencyBRL }}
                        </span>
                        <br/>

                        Valor Total Recebido:
                        <span class="total-received">
                            {{ data.summary_value | currencyBRL }}
                        </span>
                        <br/>

                        Operador/Caixa: <span class="box-operator">{{ user.first_name }}</span><br/>
                    </div>

                    Data/Hora: 
                    <span class="payment-data">
                        {{ data.created_at | moment('DD/MM/YYYY [às] HH:mm') }}
                    </span>
                    <br/>
                </div>
                <br/>
                <br/>
                <p class="text-center">
                    <small>Desenvolvido por <b>www.appfacilita.com </b></small>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import { currencyBRL } from '@/filters'

    import { facilita } from '@/global'

    import { mapGetters } from 'vuex'

    const defaultData = () => ({
        units: [],
        availability: null,
        entry_value: 0,
        total_value: 0,
        summary_value: 0,
        payments: [],
        copies: 'customer'
    })

    export default {
        name: 'ui-payment-voucher',

        filters: { currencyBRL },

        data() {
            return {
                data: { ...defaultData() }
            }
        },

        computed: {
            ...mapGetters({
                user: 'auth/getUser',
                definitions: 'launchDay/getDefinitions',
                control: 'launchDay/getControl'
            }),
            /**
             * Computed property que define quando os vouchers podem ser montados
             */
            showVouchers() {
                return this.control &&
                    this.control.deal &&
                    this.definitions &&
                    this.user &&
                    this.data
            },
            /**
             * Computed property que define o path para o logo da Facilita na S3
             */
            logoSRC() {
                return `${facilita.s3Host}_uploads/companies/${facilita.instance}/configurations/brandLogo.png`
            }
        },

        created() {
            this.$root.$on('print-payment-voucher', payload => {
                this.data = { ...payload }
                this.$nextTick(() =>{
                    this.printVouchers()
                })
            })
        },

        beforeDestroy() {
            this.$root.$off('print-payment-voucher')
        },

        methods: {
            /**
             * Computed property que retorna as informações da unidade reservada, formatadas de
             * acordo com o tipo de disponibilidade do produto
             */
            unitInfos(unit) {
                // Constrói o label para a unidade de acordo com o tipo de disponibilidade
                let infos = ''
                infos = this.data.availability && this.data.availability.type === 'vertical'
                    ? `${unit.number} - Torre ${unit.block} - Andar ${unit.floor}`
                    : `${unit.number} - Quadra ${unit.block}`
                infos += ` - ${this.$options.filters.currencyBRL(unit.cost)}`

                return infos
            },
            /**
             * Imprime o conteúdo da div que representa o comprovante de reserva
             */
            printVouchers() {
                const copies = this.data.copies.split(',')

                // Pega todas as tags style para adicionar as classes CSS no modal
                let stylesHtml = '';
                for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                    stylesHtml += node.outerHTML
                }
                stylesHtml += `
                    <style type="text/css">
                        @media print {
                            @page {
                                size: portrait !important;
                                width: 80mm;
                                margin: 0px;
                            }
                        }
                    </style>
                `

                const printWindow = window.open('', 'PRINT', 'height=600,width=400')
                printWindow.document.write(`<html><head>${stylesHtml}<title>Imprimir Comprovante</title></head><body>`)
                for (const copy of copies) {
                    printWindow.document.write(this.$refs[copy].innerHTML)
                }
                printWindow.document.write('</body></html>')

                printWindow.document.close() // Necessary for IE >= 10
                printWindow.focus() // Necessary for IE >= 10*/

                printWindow.addEventListener('load', () => {
                    printWindow.print()
                    printWindow.close()
                    this.data = { ...defaultData() }
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>